import { parseISO } from "date-fns";

export const WT_COLOR = "#0f766e";

export const DAY_HOUR_HEIGHT = 60; // px per hour

export function toMinutes(d) {
  return d.getHours() * 60 + d.getMinutes();
}

// Convert an enriched job into a positioned event object
export function jobToEvent(j) {
  const start = parseISO(j.scheduled_date);
  const startMin = toMinutes(start);
  const dur = Number(j.duration_hours) || 0;
  const endMin = Math.min(24 * 60, startMin + Math.round(dur * 60));
  return { job: j, start, startMin, endMin, dur };
}

// Assign overlapping events to side-by-side columns (Outlook-style)
export function layoutDayEvents(events) {
  const evs = events
    .map((e) => ({ ...e }))
    .sort((a, b) => a.startMin - b.startMin || b.endMin - a.endMin);
  const colEnds = [];
  evs.forEach((ev) => {
    let placed = false;
    for (let i = 0; i < colEnds.length; i++) {
      if (colEnds[i] <= ev.startMin) {
        ev.col = i;
        colEnds[i] = ev.endMin;
        placed = true;
        break;
      }
    }
    if (!placed) {
      ev.col = colEnds.length;
      colEnds.push(ev.endMin);
    }
  });
  let clusterEnd = -1;
  let cluster = [];
  const finalize = () => {
    if (!cluster.length) return;
    const cols = Math.max(...cluster.map((e) => e.col)) + 1;
    cluster.forEach((e) => { e.cols = cols; });
    cluster = [];
  };
  evs.forEach((ev) => {
    if (ev.startMin >= clusterEnd) {
      finalize();
      clusterEnd = ev.endMin;
    } else {
      clusterEnd = Math.max(clusterEnd, ev.endMin);
    }
    cluster.push(ev);
  });
  finalize();
  return evs;
}

// Compute the hour range [startH, endH) that fits all events, with sensible defaults
export function computeRange(events, defStart = 7, defEnd = 19) {
  let startH = defStart, endH = defEnd;
  events.forEach((e) => {
    startH = Math.min(startH, Math.floor(e.startMin / 60));
    endH = Math.max(endH, Math.ceil(e.endMin / 60));
  });
  startH = Math.max(0, startH);
  endH = Math.min(24, Math.max(endH, startH + 1));
  return { startH, endH };
}

export const STATUS_LABELS = {
  scheduled: "Scheduled",
  in_progress: "In Progress",
  completed: "Complete",
  cancelled: "Cancelled",
  paused: "Paused",
};

export const STATUSES = ["scheduled", "in_progress", "completed", "cancelled", "paused"];

export const DAYS = [
  { key: "mon", label: "Monday" },
  { key: "tue", label: "Tuesday" },
  { key: "wed", label: "Wednesday" },
  { key: "thu", label: "Thursday" },
  { key: "fri", label: "Friday" },
  { key: "sat", label: "Saturday" },
  { key: "sun", label: "Sunday" },
];
